import type { ImageAsset } from "@/types/references";

export function normalizeImageAsset(
	asset?: ImageAsset | null,
	fallbackAlt?: string
): { url: string; alt: string } | undefined {
	if (!asset) return undefined;

	const url =
		firstMediaUrl(asset.custom) ??
		firstMediaUrl(asset.acquia) ??
		firstMediaUrl(asset.image_field) ??
		nonEmptyString(asset.image);

	if (!url) return undefined;

	const alt = nonEmptyString(asset.image_alt_text) ?? fallbackAlt ?? "";
	return { url, alt };
}

const WIDEN_JPEG_RENDITION = /^\/content\/([^/]+)\/jpe?g\/(.+)\.jpe?g$/i;

export function toTransparentRendition(url: string): string {
	try {
		const parsed = new URL(url);
		if (!parsed.hostname.endsWith("widen.net")) return url;
		const match = parsed.pathname.match(WIDEN_JPEG_RENDITION);
		if (!match) return url;
		parsed.pathname = `/content/${match[1]}/webp/${match[2]}.webp`;
		return parsed.toString();
	} catch {
		return url;
	}
}

function firstMediaUrl(
	list: Array<{ url?: string | null; thumbnailUrl?: string }> | undefined
): string | undefined {
	if (!list?.length) return undefined;
	return nonEmptyString(list[0].url) ?? nonEmptyString(list[0].thumbnailUrl);
}

function nonEmptyString(value: string | null | undefined): string | undefined {
	return value && value.trim() !== "" ? value : undefined;
}
